import { Component, HostListener, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { GridApi } from 'ag-grid-community';
import { IseSupplierCodeRendererComponent } from './ise-supplier-code-renderer/ise-supplier-code-renderer.component';
import { IseIetTitleRendererComponent } from './ise-iet-title-renderer/ise-iet-title-renderer.component';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { LookupService } from '../services/lookup.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BusinessEntityService } from '../services/business-entity.service';
import { distinctUntilChanged } from 'rxjs';
import { AgGridSortingService } from '../services/ag-grid-sorting.service';
@Component({
  selector: 'app-ise',
  templateUrl: './ise.component.html',
  styleUrl: './ise.component.css'
})
export class IseComponent implements OnInit{
  isOpen1=true;
  isOpen2=true;
  gridApi:GridApi;
  gridColumnApi:any;
  domLayout='autoHeight';
  paginationPageSize=4;
  paginationPageSizeSelector = [4, 10, 20, 50, 100];
  leadBuyerEmail='joe@toyota.com';
  selectedTabIndex=0;
  breadcrumbItems=[{
    label: 'Home',
    link: '/home',
    icon: '>'
  },
  {
    label: 'View/Edit ISE',
    link: null,
    icon: ''
  },];
  showIETSection = false;
  gridApiMap = new Map<string, any>();
  supplierDocument: { id: number; file_name: string } | null = null;
  supplierId: string | number | null = null;
  isDocumentActionInProgress = false;
  selectedSupplierDocumentFile: File | null = null;
  selectedSupplierDocumentFileName = '';
  supplierDocumentMessage = '';
  supplierDocumentMessageTimeout: ReturnType<typeof setTimeout> | null = null;
  isIseDataInitialized = false;
  readonly maxSupplierDocumentSizeInBytes = 10 * 1024 * 1024;
  readonly allowedSupplierDocumentExtensions = ['pdf', 'docx', 'xlsx', 'csv'];


  defaultColDef={ 
    suppressNavigable: true,
    cellClass: 'no-border',
    suppressMovable: true,
    sortable: false,
    unSortIcon: true,
    wrapText: true,
    autoHeight: true,
    resizable: true,
    suppressHeaderMenuButton: true,
    suppressFloatingFilterButton: true,
   };

   defaultColDefiet={ 
    suppressNavigable: true,
    cellClass: 'no-border',
    suppressMovable: true,
    sortable: true,
    unSortIcon: true,
    wrapText: true,
    autoHeight: true,
    resizable: true,
    suppressHeaderMenuButton: true,
    suppressFloatingFilterButton: true,
   };

   columnDefSupplierContacts=[
    {
      headerName: 'Supplier Division',
      field: 'supplierdivision',
      flex: 1
    },
    {
      headerName: 'WARP Contact Type',
      field: 'warpcontacttype',
      flex: 1
    },
    {
      headerName: 'Name',
      field: 'name',
      flex: 1
    },
    {
      headerName: 'Title',
      field: 'title',
      flex: 1
    },
    {
      headerName: 'Email',
      field: 'email',
      flex: 1
    }
  ]

   rowDataSupplierContacts=[];

   columnDefSuppliers = [
    {
      headerName: 'Supplier Code',
      field: 'suppliercode',
      cellRenderer: IseSupplierCodeRendererComponent,
      flex: 1
    },
    {
      headerName: 'Supplier Name',
      field: 'suppliername',
      flex: 2
    }
  ]

   rowDataSuppliers = [];
   
  columnDefIndividualExpectedTasks=[]
  rowDataIndividualExpectedTasks=[]
  iseForm:FormGroup;
  isSupplierApproved: boolean;

  constructor(private readonly ngxSpinner:NgxSpinnerService,private readonly lookup:LookupService,private readonly sortService:AgGridSortingService,
    private readonly router: Router,private readonly formBuilder:FormBuilder,private readonly bservice:BusinessEntityService ){
      this.columnDefIndividualExpectedTasks=[
        {
          headerName: 'Title',
          field: 'title',
          cellRenderer: IseIetTitleRendererComponent,
          minWidth: 120,
          flex: 2,
          comparator: this.sortService.stringComparator
        },
        {
          headerName: 'Body',
          field: 'body',
          minWidth: 400,
          flex: 5,
          cellRenderer: (params) => {
            return params.value ? this.parseHTMLContent(params.value) : ''
          },
          comparator: this.sortService.stringComparator
        },
        {
          headerName: 'Date Entered',
          field: 'dateentered',
          minWidth: 100,
          flex: 1,
          cellRenderer: (params) => {
            return params.value ? this.formatDate(params.value) : ''
          }
        }
      ]
    }

  ngOnInit(): void {
    this.ngxSpinner.show();
    this.iseForm=this.formBuilder.group({
      description:new FormControl(''),
      purchasing:new FormControl('')
    })
    this.initializeIseDataIfReady();
    this.lookup.localStorageData.pipe(distinctUntilChanged()).subscribe({
      next: (data)=>{
        if(data?.includes('success')) {
          this.initializeIseDataIfReady();
        }}})
    this.isSupplierApproved = sessionStorage.getItem("supplierapproved") === "true";
    this.iseForm.controls.description.disable();
    this.iseForm.controls.purchasing.disable();
    setTimeout(()=>{
      this.ngxSpinner.hide();
    }, 2000);
  }

  initializeIseDataIfReady() {
    const appParentId = sessionStorage.getItem('appParentId') || this.bservice?.appParentId;
    if(!appParentId || this.isIseDataInitialized) {
      return;
    }

    if(!sessionStorage.getItem('appParentId')) {
      sessionStorage.setItem('appParentId', appParentId);
    }

    this.isIseDataInitialized = true;
    this.showIndividualExpectedTask();
    this.showISEDetails();
  }

  formatDate(value) {
    //From backend we are receiving timestamp in MST format ending with Z, so we are using UTC to display as same in all timestamp displaying places
    const isoformattedDate = value.replace(' ', 'T');
    const parsedDate = new Date(isoformattedDate);
    return new Intl.DateTimeFormat('en-US', {  //NOSONAR
      timeZone: 'UTC',
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(parsedDate);
  }

  newiet(){
    this.router.navigate(['/newiet']);
  }

  reorder(){
    this.router.navigate(['/reorderiet']);
  }
  showIndividualExpectedTask(){
    this.lookup.getIndividualExpectedTask(sessionStorage.getItem("appParentId")).subscribe(data=>{
      this.rowDataIndividualExpectedTasks=data.body.response;
    })
  }

  parseHTMLContent(value: string) {
    const parser = new DOMParser();
    const parsedHTML = parser.parseFromString(value, 'text/html');
    return parsedHTML.body.textContent || '';
  }

  showbody:any=[];
  show(){
    this.ngxSpinner.show()
    setTimeout(() => {
      this.showbody={
        "status":this.showIETSection,
        "appparentid":sessionStorage.getItem("appParentId")
      }
      this.lookup.updateRow(this.showbody).subscribe(_data=>{
      })
      this.ngxSpinner.hide()
    }, 2000);
    
  }



  showISEDetails(){
    this.lookup.getISEDetails(sessionStorage.getItem("appParentId"), this.bservice.loggedUserEmployeeId).subscribe(data=>{
      this.rowDataSupplierContacts=data.body.response.appSupplierDivisionContact;
      this.rowDataSuppliers=data.body.response.appSupplierPlants;
      this.iseForm.controls['description'].setValue(data.body.response.appISEDetails[0].description);
      this.iseForm.controls['purchasing'].setValue(data.body.response.appISEDetails[0].name);
      this.leadBuyerEmail=data.body.response.appISEDetails[0].leadbuyeremail;
      this.isSupplierApproved = data.body.response.appISEDetails[0].approved === true;
      sessionStorage.setItem("supplierapproved", `${this.isSupplierApproved}`);
      this.showIETSection=data.body.response.appISEDetails[0].display_iet;
      this.supplierId = this.resolveSupplierId();
      this.supplierDocument = this.mapSupplierDocument(data?.body?.response?.supplierDocuments);
      this.selectedSupplierDocumentFile = null;
      this.selectedSupplierDocumentFileName = '';
    })
  }

  mapSupplierDocument(supplierDocuments: any): { id: number; file_name: string } | null {
    if(!Array.isArray(supplierDocuments) || supplierDocuments.length === 0) {
      return null;
    }

    const document = supplierDocuments[0];
    const documentFileName = document?.file_name || document?.fileName;
    if(!document?.id || !documentFileName) {
      return null;
    }

    return {
      id: Number(document.id),
      file_name: documentFileName
    };
  }

  resolveSupplierId(): string | number | null {
    return sessionStorage.getItem('appParentId');
  }

  openSupplierDocumentFileSelector(input: HTMLInputElement) {
    if(this.isDocumentActionInProgress || this.isSupplierApproved) {
      return;
    }

    input.value = '';
    input.click();
  }

  onSupplierDocumentSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    this.clearSupplierDocumentMessage();

    if(!file) {
      return;
    }

    const extension = file.name.split('.').pop()?.toLowerCase();
    if(!extension || !this.allowedSupplierDocumentExtensions.includes(extension)) {
      this.showSupplierDocumentMessage('Only PDF, DOCX, XLSX and CSV files are allowed.');
      this.clearSelectedSupplierDocument();
      return;
    }

    if(file.size > this.maxSupplierDocumentSizeInBytes) {
      this.showSupplierDocumentMessage('File size cannot exceed 10 MB.');
      this.clearSelectedSupplierDocument();
      return;
    }

    this.selectedSupplierDocumentFile = file;
    this.selectedSupplierDocumentFileName = file.name;
  }

  clearSelectedSupplierDocument() {
    this.selectedSupplierDocumentFile = null;
    this.selectedSupplierDocumentFileName = '';
  }

  uploadSupplierDocument() {
    if(this.isSupplierApproved || !this.selectedSupplierDocumentFile) {
      return;
    }

    const entityId = this.getSupplierEntityId();
    if(!entityId) {
      this.showSupplierDocumentMessage('Unable to identify supplier for upload.');
      return;
    }

    this.isDocumentActionInProgress = true;
    this.clearSupplierDocumentMessage();
    const formData = new FormData();
  const appParentId = sessionStorage.getItem('appParentId') || '';
    formData.append('file', this.selectedSupplierDocumentFile);
  formData.append('appparentid', appParentId);
  formData.append('supplierid', appParentId);
    formData.append('employeeid', `${this.bservice.loggedUserEmployeeId || ''}`);

    this.lookup.uploadSupplierDocument(entityId, formData).subscribe({
      next: (data) => {
        const supplierDocument = data?.supplierDocument || data?.body?.supplierDocument || data?.body?.response?.supplierDocument;
        const uploadedFileName = supplierDocument?.file_name || supplierDocument?.fileName;
        if(supplierDocument?.id && uploadedFileName) {
          this.supplierDocument = {
            id: Number(supplierDocument.id),
            file_name: uploadedFileName
          };
        }

        this.showSupplierDocumentMessage(data?.message || data?.body?.message || 'Document uploaded successfully');
        this.clearSelectedSupplierDocument();
        this.isDocumentActionInProgress = false;
      },
      error: (_error) => {
        this.isDocumentActionInProgress = false;
        this.showSupplierDocumentMessage('Failed to upload document.');
      }
    })
  }

  viewSupplierDocument() {
    if(!this.supplierDocument?.id) {
      return;
    }

    this.lookup.getSupplierDocumentSignedUrl(this.supplierDocument.id).subscribe({
      next: (data) => {
        const documentUrl = data?.url || data?.body?.url || data?.body?.response?.url;
        if(documentUrl) {
          window.open(documentUrl, '_blank');
          return;
        }
        this.showSupplierDocumentMessage('Unable to open document.');
      },
      error: (error) => {
        if(error?.status === 404) {
          this.showSupplierDocumentMessage('Document no longer exists.');
          return;
        }
        this.showSupplierDocumentMessage('Unable to open document.');
      }
    })
  }

  deleteSupplierDocument() {
    if(this.isSupplierApproved || this.isDocumentActionInProgress || !this.supplierDocument) {
      return;
    }

    const entityId = this.getSupplierEntityId();
    if(!entityId) {
      this.showSupplierDocumentMessage('Unable to identify supplier for delete.');
      return;
    }

    this.isDocumentActionInProgress = true;
    this.clearSupplierDocumentMessage();
    this.lookup.deleteSupplierDocument(entityId).subscribe({
      next: (_data) => {
        this.supplierDocument = null;
        this.clearSelectedSupplierDocument();
        this.isDocumentActionInProgress = false;
        this.showSupplierDocumentMessage('Document deleted successfully');
      },
      error: (_error) => {
        this.isDocumentActionInProgress = false;
        this.showSupplierDocumentMessage('Failed to delete document.');
      }
    })
  }

  showSupplierDocumentMessage(message: string) {
    if(this.supplierDocumentMessageTimeout) {
      clearTimeout(this.supplierDocumentMessageTimeout);
      this.supplierDocumentMessageTimeout = null;
    }

    this.supplierDocumentMessage = message;
    if(!message) {
      return;
    }

    this.supplierDocumentMessageTimeout = setTimeout(() => {
      this.supplierDocumentMessage = '';
      this.supplierDocumentMessageTimeout = null;
    }, 3000);
  }

  clearSupplierDocumentMessage() {
    this.showSupplierDocumentMessage('');
  }

  getSupplierEntityId(): string | number | null {
    return sessionStorage.getItem('appParentId');
  }
  
  onTabChanged(_event: MatTabChangeEvent) {
    
  }

  generatePDF() {
    const appParentId = this.supplierId || sessionStorage.getItem('appParentId');
    if(!appParentId) {
      return;
    }

    this.ngxSpinner.show();
    this.lookup.getGeneratedPDF(appParentId).subscribe({
      next: data=>{
        if(data['statusCode'] === 200) {
          const a = document.createElement('a');
          a.href = data['body']['fileurl'];
          a.target = '_blank';
          a.rel = 'noreferrer noopener';
          if(a) {
            window.open(a.href, '_blank');
          }
        }
        this.ngxSpinner.hide();
      },
      error: _error => {
        this.ngxSpinner.hide();
      }
    });
  }

  openHomeScreen() {
    this.ngxSpinner.show();
    this.router.navigate(['/home']);
  }

  onGridReady(params:any, gridKey: string): void{
    this.gridApiMap.set(gridKey, params.api);
    params.api.sizeColumnsToFit();
  }
  @HostListener("window:resize", ['$event'])
  onResize(): void {
    this.resizeAllGrids();
  }

  resizeAllGrids(): void {
    this.gridApiMap.forEach((gridApi) => {
      if(gridApi) {
        gridApi.sizeColumnsToFit();
        gridApi.refreshCells();
      }
    })
  }
}
